import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n";
import { Logo } from "@/components/Logo";
import { LangToggle } from "@/components/Navbar";

const WORLDS = [
  { id: "aws", path: "/aws", num: "01", accent: "#f59c1a" },
  { id: "martech", path: "/martech", num: "02", accent: "#ca3b42" },
  { id: "people", path: "/people-hr", num: "03", accent: "#0d9488" },
];

const Gateway = () => {
  const { t } = useLang();

  return (
    <div data-testid="gateway-page" className="min-h-[100svh] bg-[#FAFAFD] text-[#353535] flex flex-col">
      <div className="flex items-center justify-between px-5 sm:px-8 pt-6">
        <Logo />
        <LangToggle />
      </div>

      <div className="flex-1 flex flex-col justify-center px-5 sm:px-8 py-16">
        <div className="mx-auto w-full max-w-[1240px]">
          {WORLDS.map((w, i) => {
            const c = t.gateway.worlds[w.id];
            return (
              <motion.div
                key={w.id}
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.55, delay: 0.15 + i * 0.1 }}
              >
                <Link
                  to={w.path}
                  data-testid={`gateway-select-${w.id}`}
                  className="group grid gap-4 lg:grid-cols-[90px_1.1fr_1fr_64px] items-center border-t border-black/10 last:border-b py-10 sm:py-12"
                >
                  <span className="font-jbmono text-sm" style={{ color: w.accent }}>({w.num})</span>
                  <div>
                    <div className="font-jbmono text-[10px] uppercase tracking-[0.25em] text-[#999999] mb-2">{c.tag}</div>
                    <h2 className="font-cabinet text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight transition-transform duration-500 group-hover:translate-x-3">
                      {c.name}
                    </h2>
                  </div>
                  <div>
                    <p className="text-sm sm:text-base text-[#999999] font-jakarta leading-relaxed max-w-md">{c.desc}</p>
                    <ul className="mt-4 flex flex-col gap-1.5">
                      {c.points.map((point, j) => (
                        <li key={j} className="flex items-center gap-2 text-sm font-jakarta text-[#353535]/80">
                          <span className="h-1.5 w-1.5 rounded-full shrink-0" style={{ backgroundColor: w.accent }} /> {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <span className="hidden lg:flex h-14 w-14 items-center justify-center justify-self-end rounded-full border border-black/15 transition-all duration-500 group-hover:bg-[#353535] group-hover:text-white group-hover:border-transparent group-hover:rotate-45">
                    <ArrowUpRight size={20} />
                  </span>
                </Link>
              </motion.div>
            );
          })}

        </div>
      </div>
    </div>
  );
};

export default Gateway;
